import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { enumTiposGestion } from "../commons/enumTipoGestion";


// Para facilitar el manejo de estados de obra
// Esto ya agrega la opcion de editar en base al estado
// Y permite obtener el nombre de gestion a partir del id de gestion obra.

const useGestionObra = (lastTipoGestionObra, lastEstadoObra, informadoSRT) => {
  const tiposDeGestion = useSelector((state) => state.obra.getTiposAvisoObra.data);

  const tiposDeGestionMemorizados = useMemo(() => {

    if (lastEstadoObra === "En Obra" && !informadoSRT) {
      return [
        {
          nombre: enumTiposGestion.edicion,
          id: enumTiposGestion.edicion
        }
      ]
    } else {
      return tiposDeGestion;
    }
  }, [tiposDeGestion, lastEstadoObra, informadoSRT]);
  const nombreTipoGestion = useCallback((idTipoGestionObra, puedeSerEdicion = false) => {
    const tipoDeGestionSeleccionada = tiposDeGestionMemorizados.find((t) => t.id == idTipoGestionObra)?.nombre;
    if (tipoDeGestionSeleccionada === enumTiposGestion.edicion && !puedeSerEdicion) {
      return lastTipoGestionObra;
    }
    return tipoDeGestionSeleccionada
  }, [lastTipoGestionObra, tiposDeGestionMemorizados])

  return [nombreTipoGestion, tiposDeGestionMemorizados];
}

export default useGestionObra;